import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import CustomerInvalidDispositionAlert, {
  ICustomerInvalidDispositionAlert
} from "../Components/Alerts/CustomerInvalidDispositionAlert";

const SessionContextCustomerInvalidDispositionAlert: React.FC = SessionContextValueProvider<
  ICustomerInvalidDispositionAlert,
  ICustomerInvalidDispositionAlert
>({
  Component: CustomerInvalidDispositionAlert,
  map: ({ customer }) => ({ customer })
});

export default SessionContextCustomerInvalidDispositionAlert;
